export const RECAPTCHA_V2_SITE_KEY_VALUE = '6LcXpGojAAAAAH-MNfYkEu1PVj5u-p7i26SVGMh1';
